import React from "react";

/**
 * ─── Card ──────────────────────────────────────────────────────────────────
 * Base container primitive (PDR v2.1 §8). Formalizes `.hbf-card`.
 * All content blocks that need a bordered white surface use this.
 *
 * Props
 *   title, description, headerRight   → optional structured header slot
 *   footer                            → optional footer slot (typically actions)
 *   interactive                       → adds hover elevation (for clickable cards)
 *   padding                           → "none" | "sm" | "md" (default) | "lg"
 *   testId
 *
 * If neither `title` nor `description` nor `headerRight` are provided, the
 * header slot is omitted entirely — the card becomes a plain surface.
 */
const PAD = { none: 0, sm: 12, md: 20, lg: 24 };

export default function Card({
  title, description, headerRight, footer, interactive = false,
  padding = "md", className = "", children, testId,
}) {
  const hasHeader = Boolean(title || description || headerRight);
  const classes = ["ds-card", interactive && "ds-card--interactive", className].filter(Boolean).join(" ");

  return (
    <section className={classes} data-testid={testId}>
      {hasHeader && (
        <div className="ds-card__header">
          <div>
            {title && <div className="ds-card__title">{title}</div>}
            {description && <div className="ds-card__desc">{description}</div>}
          </div>
          {headerRight && <div>{headerRight}</div>}
        </div>
      )}
      <div className="ds-card__body" style={padding === "md" ? undefined : { padding: PAD[padding] }}>
        {children}
      </div>
      {footer && <div className="ds-card__footer">{footer}</div>}
    </section>
  );
}
